var map = {
	"./ConfettiEffect": "Qr9f",
	"./ConfettiEffect.d": "ObpK",
	"./ConfettiEffect.d.ts": "ObpK",
	"./ConfettiEffect.d.ts.map": "Gz36",
	"./ConfettiEffect.js": "Qr9f",
	"./FireworksEffect": "zIwD",
	"./FireworksEffect.d": "Sq6E",
	"./FireworksEffect.d.ts": "Sq6E",
	"./FireworksEffect.d.ts.map": "Pd5g",
	"./FireworksEffect.js": "zIwD",
	"./SnowfallEffect": "Q0Yv",
	"./SnowfallEffect.d": "8vyt",
	"./SnowfallEffect.d.ts": "8vyt",
	"./SnowfallEffect.d.ts.map": "JTFo",
	"./SnowfallEffect.js": "Q0Yv",
	"./SnowstormEffect": "FErX",
	"./SnowstormEffect.d": "ngTf",
	"./SnowstormEffect.d.ts": "ngTf",
	"./SnowstormEffect.d.ts.map": "qLmH",
	"./SnowstormEffect.js": "FErX",
	"./TsparticlesEffect": "fUHm",
	"./TsparticlesEffect.d": "Zcet",
	"./TsparticlesEffect.d.ts": "Zcet",
	"./TsparticlesEffect.d.ts.map": "Gpv1",
	"./TsparticlesEffect.js": "fUHm"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = "nqrg";
module.exports = webpackContext;